import React, { createContext, useState, useContext, useEffect } from 'react';
import { auth as authApi } from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Restore session from HttpOnly cookie on mount — a 401 simply means
    // the user is not logged in, which is fine and handled silently.
    useEffect(() => {
        authApi.me()
            .then(res => setUser(res.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const login = async (credentials) => {
        const response = await authApi.login(credentials);
        const { user: userData } = response.data;
        setUser(userData);
        return userData;
    };

    const register = async (data) => {
        const response = await authApi.register(data);
        const { user: userData } = response.data;
        setUser(userData);
        return userData;
    };

    const logout = async () => {
        try { await authApi.logout(); } catch {}
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, token: null, login, register, logout, loading, isAuthenticated: !!user }}>
            {children}
        </AuthContext.Provider>
    );
};